import React, { useState, useRef } from "react";

const NomenclatureTable = ({rows, updateNomenclatures }) => {
    const maxLimit = 5;
    // const [rows, setRows] = useState([ { nomenclature: "", unit: "", service: "", quantity: "1", cost: "" }]);
    const inputRefs = useRef([]);

    const handleAddRow = () => {
        // Check if all fields of the last row are filled
        for (let i = 0; i < rows.length; i++) {
            for (const field of ["nomenclature", "unit", "service", "quantity", "cost"]) {
                if (!rows[i][field]) {
                    inputRefs.current[i][field]?.focus(); // Focus on the first empty field
                    alert("Please fill all fields before adding a new row.");
                    return;
                }
            }
        }

        if (rows.length < maxLimit) {
            const updatedRows = [...rows, { nomenclature: "", unit: "", service: "", quantity: "", cost: "" }];
            // setRows(updatedRows);
            updateNomenclatures(updatedRows);
        } else {
            alert("Maximum of 5 items allowed.");
        }
    };

    const handleRemoveRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        //setRows(updatedRows);
        updateNomenclatures(updatedRows);
    };

    const handleChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        //setRows(updatedRows);
        updateNomenclatures(updatedRows);
    };

    return (
        <div className="table-responsive">
            <table border="1" className="table" style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr>
                        <th>Nomenclature/Description</th>
                        <th>Unit of Measure</th>
                        <th>Service</th>
                        <th>QTY</th>
                        <th>Estimated Cost</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => {
                        inputRefs.current[index] = {}; // Initialize ref object for each row

                        return (
                            <tr key={index}>
                                <td>
                                    <textarea
                                        required
                                        className="form-control form-control-sm"
                                        value={row.nomenclature}
                                        ref={(el) => (inputRefs.current[index]["nomenclature"] = el)}
                                        onChange={(e) => handleChange(index, "nomenclature", e.target.value)}
                                    ></textarea>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        required
                                        className="form-control form-control-sm"
                                        value={row.unit}
                                        ref={(el) => (inputRefs.current[index]["unit"] = el)}
                                        onChange={(e) => handleChange(index, "unit", e.target.value)}
                                    />
                                </td>
                                <td>
                                    <select
                                        className="form-control form-control-sm"
                                        value={row.service}
                                        required
                                        ref={(el) => (inputRefs.current[index]["service"] = el)}
                                        onChange={(e) => handleChange(index, "service", e.target.value)}
                                    >
                                        <option value={""}>Select</option>
                                        <option value={"C"}>C</option>
                                        <option value={"NC"}>NC</option>
                                        <option value={"NCF"}>NCF</option>
                                    </select>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        value={row.quantity}
                                        style={{ width: "100px" }}
                                        required
                                        ref={(el) => (inputRefs.current[index]["quantity"] = el)}
                                        onChange={(e) => handleChange(index, "quantity", e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        value={row.cost}
                                        required
                                        ref={(el) => (inputRefs.current[index]["cost"] = el)}
                                        onChange={(e) => handleChange(index, "cost", e.target.value)}
                                    />
                                </td>
                                <td>
                                    {(rows.length < maxLimit && rows.length === index + 1) ? (
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-success me-2"
                                            onClick={handleAddRow}
                                        >
                                            <i className="fa-solid fa-plus"></i>
                                        </button>
                                    ) : null}
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-danger"
                                        onClick={() => handleRemoveRow(index)}
                                        disabled={rows.length === 1}
                                    >
                                        <i className="fa-solid fa-xmark"></i>
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default NomenclatureTable;
